import axios from 'axios';
import { string } from 'mobx-state-tree/dist/internal';

const hereApiKey = '&apiKey=vk-GXonjgirxGxbr01Aa0M4HGmCnHgrav5b5Wb21lNI';

interface HerePosition {
  lat: number;
  lng: number;
}

interface HereAddress {
  city: string;
  district?: string;
  postalCode: string;
}

interface HereSearchResultItem {
  resultType: string;
  address: HereAddress;
  position: HerePosition;
}

interface HereSearchResult {
  items: Array<HereSearchResultItem>;
}

export const getHERECoordinatesFromAddress = async (address: string) => {
  const formattedAddress = address.trim().replace(new RegExp('\\s+'), '+') + '.json';
  const completeUrl = 'https://geocode.search.hereapi.com/v1/geocode?q=' + formattedAddress + hereApiKey;

  const promise = axios.get<HereSearchResult>(completeUrl, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  const data = await promise.then((res) => {
    if (res.status === 200) return res.data.items;
  });

  return data;
};

export const getHEREAddressFromCoordinates = async (lat: string, lng: string) => {
  const completeUrl =
    'https://revgeocode.search.hereapi.com/v1/revgeocode?at=' +
    lat +
    '%2C' +
    lng +
    '&apiKey=vk-GXonjgirxGxbr01Aa0M4HGmCnHgrav5b5Wb21lNI';

  const promise = axios.get(completeUrl, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  const data = await promise.then((res) => {
    return res;
  });

  return data;
};
